import React from "react";
import {useSelector} from "react-redux";

function useAdminUserSession() {
    const session = useSelector((state) => state.adminLogin.adminUserSession);

    return {
        session
    }
}

export default useAdminUserSession;